import React, { useEffect, useState } from "react";
import { Layout, Spin, message, Button, Space } from "antd";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import axios from "../../services/axiosInstance";
import { useParams } from "react-router-dom";
import {
  FETCH_SIGNED_DOCUMENT_FROM_EMAIL,
  TOGGLE_REMINDER_EMAIL_AS_RENEWED,
} from "../../services/apiEndPoints";

export const isPdf = (url: string) => {
  return url.toLowerCase().includes(".pdf");
};

const DocumentSingleComponent: React.FC = () => {
  const params = useParams();
  const documentId = params.id;

  const [signedUrl, setSignedUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [renewing, setRenewing] = useState(false);

  const fetchSignedUrl = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        FETCH_SIGNED_DOCUMENT_FROM_EMAIL(documentId || "")
      );

      if (response?.data?.results) {
        setSignedUrl(response.data.results);
      } else {
        throw new Error("Invalid response");
      }
    } catch (error) {
      message.error("Failed to load document");
    } finally {
      setLoading(false);
    }
  };

  const handleRenewToggle = async (documentId: string) => {
    try {
      await axios.put(TOGGLE_REMINDER_EMAIL_AS_RENEWED(documentId), {});
      message.success("Renewal completed");
    } catch {
      message.error("Failed to update renewal status");
    }
  };

  useEffect(() => {
    if (documentId) {
      fetchSignedUrl();
    } else {
      message.error("No document ID provided");
    }
  }, [documentId]);

  return (
    <Layout style={{ background: "transparent", textAlign: "center" }}>
      {(loading || renewing) && <Spin size="large" />}

      {!loading && signedUrl && (
        <Space style={{ marginBottom: 16 }}>
          <Button
            icon={<ReloadOutlined />}
            onClick={() => {
              if (documentId) {
                handleRenewToggle(documentId);
              } else {
                message.error("Document ID is missing");
              }
            }}
            loading={renewing}
          >
            Mark as Renewed
          </Button>

          <a
            href={signedUrl}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button type="primary" icon={<DownloadOutlined />}>
              Download
            </Button>
          </a>
        </Space>
      )}

      {!loading && signedUrl && isPdf(signedUrl) && (
        <iframe
          src={signedUrl}
          width="100%"
          style={{ height: "80vh", border: "none" }}
          title="PDF Preview"
        />
      )}

      {!loading && signedUrl && !isPdf(signedUrl) && (
        <img
          src={signedUrl}
          alt="Document Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "80vh",
            objectFit: "contain",
            display: "block",
            margin: "0 auto",
          }}
        />
      )}
    </Layout>
  );
};

export default DocumentSingleComponent;
